import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "../SpaceDialogAction";

const DialogNotDeleteForLessThanTwoStudentsRemaining = ({
	dialog
}) => {
	return (
		<SpaceDialogAction
			dialog={dialog}
			title="No se puede eliminar a los alumnos seleccionados"
			content="Recuerda que las reservas de salas grupales deben tener un mínimo de dos alumnos.">
			<CustomButton
				width="120px"
				text="Cerrar"
				onClick={dialog.hide} />
		</SpaceDialogAction>
	);
}

export default DialogNotDeleteForLessThanTwoStudentsRemaining;